function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.006.5a.5.5 0 0 0-.252.064l-8 4.5A.5.5 0 0 0 1.5 5.5v9a.5.5 0 0 0 .254.436l8 4.5a.5.5 0 0 0 .492 0l8-4.5a.5.5 0 0 0 .254-.436v-9a.5.5 0 0 0-.254-.436l-8-4.5a.5.5 0 0 0-.24-.064zM10 1.574 16.979 5.5 10 9.426 3.021 5.5 10 1.574zM2.5 6.355l7 3.938v7.852l-7-3.938V6.355zm15 0v7.852l-7 3.938v-7.852l7-3.938z",
    style: {
      fill: "#222",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0
    },
    id: "layer1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.5ad814f5fd5a687a2d523596f5250f35.svg";
export { ForwardRef as ReactComponent };